// Action xử lý các chỉ tiêu trùng, thiếu, thừa
export default {
  NoAction: 0,
  AddActivity: 1, // Thêm chỉ tiêu: thiếu nên cần bổ sung
  RemoveActivity: 2, // Bỏ chọn chỉ tiêu: thừa nên cần bỏ đi
  ReselectActivity: 3 || 4, // Chọn lại chỉ tiêu: trùng nên cần chọn lại
};
